import { useState } from 'react';
import { FormAutocompleteInput } from '@/components';
import { useUsersOptions } from '../hooks';
import { Option } from '@/components/inputs/AutocompleteInput';
import { Control } from 'react-hook-form';

interface SearchUserProps {
  name: string;
  placeholder?: string;
  control: Control<any>;
  required?: boolean;
  onUserSelect?: (userId: string, fullName: string) => void;
  showSelectedUserInfo?: boolean;
  minWidth?: string;
  value?: Option | null;
}

const SearchUser = ({
  name,
  placeholder = 'Buscar usuario',
  control,
  required = false,
  onUserSelect,
  showSelectedUserInfo = false,
  minWidth = 'min-w-[300px]',
  value,
}: SearchUserProps) => {
  const [userSearch, setUserSearch] = useState('');
  const [selectUser, setSelectUser] = useState<Option | null>(null);

  const { userOptions, isUsersLoading } = useUsersOptions({
    search: userSearch,
  });

  const handleUserSelect = (newValue: Option | null) => {
    setSelectUser(newValue?.data ? newValue : null);
    if (onUserSelect && newValue?.data) {
      onUserSelect(newValue.data.id, newValue.data.fullName);
    } else if (onUserSelect && !newValue) {
      onUserSelect('', '');
    }
  };

  const selectedValue = value ?? selectUser;

  return (
    <div className={minWidth}>
      {userSearch.length > 0 && userSearch.length < 3 && (
        <div className="text-gray-500 text-xs absolute -mt-5">
          Escribe al menos 3 letras para buscar usuarios.
        </div>
      )}
      <FormAutocompleteInput
        name={name}
        placeholder={isUsersLoading ? 'Cargando...' : placeholder}
        control={control}
        value={selectedValue}
        options={userOptions}
        required={required}
        onInputChange={setUserSearch}
        onChange={handleUserSelect}
      />
      {showSelectedUserInfo && selectedValue && selectedValue.data && (
        <div className="flex flex-col gap-1 mt-2">
          <div className="grid grid-cols-[max-content_1fr] gap-x-2 gap-y-1 items-center mb-5">
            <strong>Usuario seleccionado: </strong>
            <span>{selectedValue.data.fullName}</span>
            <strong>Email: </strong>
            <span>{selectedValue.data.email}</span>
            <strong>Teléfono: </strong>
            <span>{selectedValue.data.phone}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchUser; 